import React from 'react';

const defaultCopyright = () =>
  `Copyright © ${new Date().getFullYear()} GEO系统 All Rights Reserved`;

const Footer: React.FC = () => {
  const siteSettingStr = typeof window !== 'undefined' ? localStorage.getItem('siteSetting') : null;
  let copyright = defaultCopyright();
  let icp = '';

  if (siteSettingStr) {
    try {
      const siteSetting = JSON.parse(siteSettingStr) as { copyright?: string; icp?: string };
      if (siteSetting.copyright) {
        copyright = siteSetting.copyright;
      }
      if (siteSetting.icp) {
        icp = String(siteSetting.icp).trim();
      }
    } catch (e) {
      // 解析失败使用默认
    }
  }

  return (
    <div
      style={{
        textAlign: 'center',
        padding: '16px 50px',
        color: 'rgba(0, 0, 0, 0.45)',
        fontSize: '14px',
        lineHeight: 1.6,
      }}
    >
      <div>{copyright}</div>
      {icp ? <div style={{ marginTop: 4 }}>{icp}</div> : null}
    </div>
  );
};

export default Footer;
